import { render, staticRenderFns } from "./validateErrorDialog.vue?vue&type=template&id=24b8faa4"
import script from "./validateErrorDialog.vue?vue&type=script&lang=js"
export * from "./validateErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports